
export const Navbar_Link_Data = 
[
  {path: '/', pathName: 'Homepage'},
  {path: '/Art', pathName: 'Art'},
  {path: '/About', pathName: 'About'},
  {path: '/Contact', pathName: 'Contact'},
];